import type { ModelNavigateOptions } from "./model-navigate.type";
import type { ModelKey } from "@/modules/model";

import { useNavigate } from "react-router";

import { useModelLink } from "@/modules/model-link";

export const useModelNavigate = () => {
  const navigate = useNavigate();
  const { getModelLink } = useModelLink();

  const navigateToModel = (
    modelKey: ModelKey,
    { context, id, search, replace, state }: ModelNavigateOptions = {}
  ) => {
    const link = getModelLink(modelKey, { context, id, search });
    if (link) navigate(link, { replace, state });
  };

  return {
    navigateToModel,
  };
};
